import React, { useEffect, useState } from 'react'
import { Row, Col } from 'antd'
import { translate } from 'i18n'
import TKeys from 'i18n/translationKey'
import CheckAsOptions from './CheckAsOptions'
import { SearchInput } from '../Form'
import { cloneDeep } from 'lodash'
import { hasText } from 'utils/getText'

interface Props {
  filter: string[]
  onChange(filter: string[]): void
  zones: string[]
  hasSearch?: boolean
}

const ZoneContent: React.FunctionComponent<Props> = ({
  filter,
  onChange,
  zones,
  hasSearch = false,
}) => {
  const [textSearch, setTextsearch] = useState('')
  const [dataFilter, setDataFilter] = useState([] as string[])

  useEffect(() => {
    setDataFilter(cloneDeep(zones))
  }, [hasSearch, zones])

  useEffect(() => {
    if (!hasSearch) return
    const list = cloneDeep(zones)
    let filter = []
    if (textSearch === '') {
      filter = list
    } else {
      filter = list.filter(item => hasText(item, textSearch))
    }

    setDataFilter(filter)
  }, [textSearch])

  const onValueChange = (val: string) => {
    const index = filter.findIndex(item => item === val)
    if (index >= 0) {
      filter.splice(index, 1)
    } else {
      filter.push(val)
    }
    onChange(filter)
  }

  const onClear = () => {
    filter = []
    onChange(filter)
  }

  const content = () => {
    return dataFilter.map((item, index) => {
      const findIndex = filter.findIndex(it => it == item)
      return (
        <Col span={24} key={index}>
          <CheckAsOptions
            key={index}
            title={item}
            value={findIndex >= 0}
            item={item}
            onChange={onValueChange}
          />
        </Col>
      )
    })
  }

  const clearBtn =
    filter.length > 0 ? (
      <span onClick={onClear} className="filter-clear std-font-regular">
        {translate(TKeys.Common.cancel_all)}
      </span>
    ) : (
      undefined
    )
  return (
    <div className="std-font-regular" style={css.page}>
      <Row>
        <Col span={24}>
          <div className="std-font-bold" style={css.title}>
            {translate(TKeys.Dashboard.zone)}
            {hasSearch && (
              <SearchInput onSearch={setTextsearch} searchTxt={textSearch} />
            )}
            {clearBtn}
          </div>
        </Col>
      </Row>
      <Row className="pop-over-container-choices">{content()}</Row>
    </div>
  )
}

const css: any = {
  page: {
    width: '296px',
    height: 'auto',
    padding: '25px 24px',
  },
  title: {
    textAlign: 'left',
    color: 'black',
    fontSize: '20px',
    marginBottom: '25px',
  },
  cancel: {
    float: 'right',
    color: '#003168',
    fontSize: '18px',
  },
}

export default ZoneContent
